// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ListUtils$SmartcutsMacros = require("../../../bs-utils/src/ListUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("./InnerTextSemantic.bs.js");

function isMergeable(_config) {
  return false;
}

function isDynamic(param) {
  return InnerTextSemantic$SmartcutsMacros.isDynamic(param.chosen);
}

function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
  var arg = config.chosen;
  return {
          intentionChoices: Belt_Array.map(config.intentionChoices, (function (param) {
                  return InnerTextSemantic$SmartcutsMacros.updatePlaybackFormLabel(playbackFormLabel, param);
                })),
          chosen: (function (param) {
                return InnerTextSemantic$SmartcutsMacros.updatePlaybackFormLabel(param, arg);
              })(playbackFormLabel)
        };
}

function MakeTransformers(AuthoringCommandValue, PlaybackCommandValue) {
  var fromAuthoringCommandValue = function (cmdVal) {
    var _lastNode = ListUtils$SmartcutsMacros.getLast(Curry._1(AuthoringCommandValue.getSelector, cmdVal));
    if (_lastNode !== undefined) {
      if (typeof _lastNode.innerText === "number") {
        return ;
      }
      var intentionChoices = InnerTextSemantic$SmartcutsMacros.getIntentionChoicesFromSelector(Curry._1(AuthoringCommandValue.getSelector, cmdVal));
      var arg = Belt_Array.get(intentionChoices, 0);
      return {
              intentionChoices: intentionChoices,
              chosen: (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                  })("Expected at least one intention choice.")
            };
    }
    console.warn("no selector last");
    
  };
  var applyToAuthoringCommandValueToGetPlaybackCommandValue = function (commandValue, maybeConfig) {
    var semantic;
    if (maybeConfig !== undefined) {
      var variableInnerTextConfig = maybeConfig.chosen;
      semantic = typeof variableInnerTextConfig === "number" || variableInnerTextConfig.TAG !== /* VariableInnerText */5 ? variableInnerTextConfig : ({
            TAG: /* VariableInnerText */5,
            _0: {
              playbackFormLabel: "[Add Label]",
              defaultValue: variableInnerTextConfig._0.defaultValue
            }
          });
    } else {
      semantic = /* AnyInnerText */0;
    }
    return Curry._2(PlaybackCommandValue.fromAuthoringCommandValueAndSemantic, commandValue, semantic);
  };
  return {
          fromAuthoringCommandValue: fromAuthoringCommandValue,
          applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
        };
}

exports.isMergeable = isMergeable;
exports.isDynamic = isDynamic;
exports.updateConfigWithPlaybackFormLabel = updateConfigWithPlaybackFormLabel;
exports.MakeTransformers = MakeTransformers;
/* InnerTextSemantic-SmartcutsMacros Not a pure module */
